/** Matches API `DrDetailApiModel` / `RegDisposalRecoveryCode` JSON (camelCase). */
export interface IDisposalRecoveryCodeDetail {
    id: string;
    code: string;
    description: string;
    isActive: boolean;
    isDeleted: boolean;
    source: string;
    sourceVersion: string;
    effectiveFromUtc: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    createdByDisplayName?: string | null;
    lastUpdatedByDisplayName?: string | null;
    deletedAuditAtUtc?: string | null;
    deletedByDisplayName?: string | null;
    disabledAuditAtUtc?: string | null;
    disabledByDisplayName?: string | null;
}

export type DisposalRecoveryCodeCreatePayload = {
    code: string;
    description: string;
    isActive?: boolean;
};

export type DisposalRecoveryCodeUpdatePayload = {
    id: string;
    code: string;
    description: string;
};

export const DR_CREATE_CONFLICT = {
    deletedRestoreAvailable: "disposalRecovery.deletedRestoreAvailable",
    duplicateActive: "disposalRecovery.duplicateActive",
} as const;
